import { DownOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  FormInstance,
  Input,
  Menu,
  Row
} from "antd";
import * as React from "react";
import { IStore } from "../../model/runtime/state/Store";
import SelectInput from "./SelectInput";
export interface State {
  realValue?: string;
}

export interface Props {
  rowData?: any;
  translate;
  organisationId?: number;
  translationObjectIdFieldName: string;
  store: IStore;
  form: FormInstance;
}
const FormFields = {
  ID: "id",
  ORGANISATION_ID: "organisationId",
  LANGUAGE_ID: "languageId",
  NAME_TRANSLATION: "nameTranslation",
  VALID: "valid"
};

export default class TranslationInputField extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      realValue: undefined
    };
  }

  render() {
    const {
      rowData,
      organisationId,
      translate,
      translationObjectIdFieldName,
      store,
      form
    } = this.props;

    const { languages } = store.getState<any>();
    const getSummaryLabel = (index: number) => {
      let languageName =
        languages.find(
          (item) =>
            item.id ===
            form.getFieldValue("nameTranslations")?.[index]?.languageId
        )?.name || undefined;
      return languageName
        ? `${translate("editors.index_type_categories.name")} (${languageName})`
        : translate("editors.index_type_categories.name");
    };

    return (
      <Form.List name="nameTranslations">
        {(fields, { add, remove }) => {
          return (
            <>
              {fields.map((field, index) => (
                <Row
                  key={field.key}
                  gutter={16}
                  className={"content-section-modal-emphasize"}
                >
                  <Col sm={24} xs={24}>
                    <Form.Item
                      name={[index, FormFields.ID]}
                      style={{ display: "none" }}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name={[index, FormFields.ORGANISATION_ID]}
                      style={{ display: "none" }}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name={[index, translationObjectIdFieldName]}
                      style={{ display: "none" }}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    {index === 0 ? (
                      <Row>
                        <Col span={6} offset={18}>
                          <Form.Item className={"mb-0"}>
                            <Dropdown
                              overlay={
                                <Menu
                                  onClick={(info) =>
                                    add({
                                      languageId: Number.parseInt(info.key, 10),
                                      organisationId: organisationId,
                                      valid: true
                                    })
                                  }
                                >
                                  {languages
                                    .filter(
                                      (language) =>
                                        form
                                          .getFieldValue("nameTranslations")
                                          ?.map((item) => item.languageId)
                                          .indexOf(language.id) === -1
                                    )
                                    ?.map((item) => (
                                      <Menu.Item key={item.id}>
                                        {item.name}
                                      </Menu.Item>
                                    ))}
                                </Menu>
                              }
                            >
                              <Button>
                                {translate(
                                  "editors.case_law_documents.add_translation"
                                )}{" "}
                                <DownOutlined />
                              </Button>
                            </Dropdown>
                          </Form.Item>
                        </Col>
                      </Row>
                    ) : null}
                  </Col>
                  <Col span={7}>
                    <Form.Item
                      name={[index, FormFields.LANGUAGE_ID]}
                      label={"Jezik"}
                    >
                      <SelectInput
                        disabled
                        selectOptionKey={"id"}
                        selectOptionValue={"name"}
                        selectOptions={store.getState<any>().languages}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={15}>
                    <Form.Item
                      label={`${getSummaryLabel(index)}`}
                      className={"mb-0"}
                      name={[index, FormFields.NAME_TRANSLATION]}
                      initialValue={
                        rowData &&
                        rowData?.nameTranslations[index]?.nameTranslation
                      }
                      rules={[
                        {
                          required: true,
                          message: translate(
                            "editors.case_law_documents.required_messages",
                            {
                              field: translate(
                                "editors.case_law_documents.summary"
                              )
                            }
                          )
                        }
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col style={{ display: "none" }}>
                    <Form.Item
                      className={"png-form-item-horizontal-checkbox "}
                      label={translate("editors.case_law_documents.valid")}
                      name={[index, FormFields.VALID]}
                      valuePropName={"checked"}
                      initialValue={
                        (rowData && rowData?.nameTranslations[index]?.valid) ??
                        true
                      }
                    >
                      <Checkbox />
                    </Form.Item>
                  </Col>

                  <Col
                    span={2}
                    style={{
                      display: "flex",
                      marginTop: 10,
                      alignItems: "center"
                    }}
                  >
                    <Button
                      danger
                      onClick={() => remove(field.name)}
                      size="small"
                      type={"link"}
                    >
                      <i
                        className={"fas fa-trash-alt"}
                        style={{ marginRight: 0 }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
              ))}
              <Row className={"content-section-modal-borderless pb-0"}>
                <Col sm={24} xs={24} style={{ textAlign: "center" }}></Col>
              </Row>
            </>
          );
        }}
      </Form.List>
    );
  }
}
